/* eslint-disable */
import './shareDg.scss';
import PopupWrapperView from '@/js/desktop/components/popup/PopupWrapper';
import template from './template.html';

const Model = Backbone.Epoxy.Model.extend({
        defaults: {
            urlLink: '',
            wasCopy: false,
        },
    });

const ShareDgView = Backbone.Epoxy.View.extend({
    el: template(),
    model: new Model(),
    bindings: {
        input: 'value:urlLink',
        button: "attr:{'disabled': wasCopy}",
    },
    events: {
        'click .js-copy-to-keyboard': 'copyToKeyboard',
        'click .shareDg__button-js': 'openShareWindow',
        'click .shareDg__button_encoded-js': 'openShareWindowEncoded',
    },
    initialize(options) {
        options = options || {};
        this.shareDg = new PopupWrapperView({
            el: this.el,
            dialogClass: 'shareDg',
        });
        this.$openLink = options.$openLink;
        this.initDOMEvents();
    },
    initDOMEvents() {
        this.$openLink.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.model.set({
                urlLink: window.location.href,
                wasCopy: false,
            });
            this.shareDg.show();
        });
    },
    copyToKeyboard(e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(e.target).is('disabled')) return;
        $('input', this.$el).select();
        document.execCommand('Copy');
        this.model.set({
            wasCopy: true,
        });
    },
    openShareWindow(e) {
        $(e.target).attr('href', $(e.target).attr('href') + this.model.get('urlLink'));
    },
    openShareWindowEncoded(e) {
        $(e.target).attr('href', $(e.target).attr('href') + encodeURIComponent(this.model.get('urlLink')));
    }
});

export default ShareDgView;